import {AfterViewInit, Component} from '@angular/core';
import {ModalController} from '@ionic/angular';
import Article from 'src/smoothr-web-app-core/models/Article';
import Compound from 'src/smoothr-web-app-core/models/Compound';
import Localization from 'src/smoothr-web-app-core/models/Localization';

@Component({
	selector: 'app-short-info-modal',
	templateUrl: './short-info-modal.component.html',
	styleUrls: ['short-info-modal.component.scss']
})
export class ShortInfoModalComponent implements AfterViewInit {
	article: Article;
	compound: Compound;
	string: string;
	constructor(private modalCtrl: ModalController) {}
	ngAfterViewInit(): void {
		console.log(Object.values(this.compound.allergens).find(it => it === true));
		console.log(Object.values(this.compound.additives).find(it => it === true));
	}
	static async show(
		modalCtrl: ModalController,
		article?: Article,
		string?: string
	) {
		console.log(article, article.compound);
		const modal = await modalCtrl.create({
			cssClass: 'short-info-modal auto-height',
			component: ShortInfoModalComponent,
			componentProps: {
				article: article,
				string: string,
				compound: article?.compound
			},
			showBackdrop: true,
			backdropDismiss: true
		});
		await modal.present();
	}

	dismiss() {
		this.modalCtrl.dismiss();
	}
	isAllergens() {
		return Object.values(this.compound?.allergens).find(it => it === true);
	}
	isAddit() {
		return Object.values(this.compound?.additives).find(it => it === true);
	}
}
